import React, { useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { Clock } from "lucide-react";

export default function Learn() {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(null);
  const [err, setErr] = useState("");

  useEffect(() => {
    (async () => {
      try { const { data } = await api.get("/learning"); setItems(data.articles || []); }
      catch (e) { setErr(formatApiError(e)); }
    })();
  }, []);

  return (
    <div className="space-y-8">
      <div>
        <div className="text-xs uppercase tracking-widest text-rose">Learning Centre</div>
        <h1 className="font-display text-5xl text-navy leading-tight">Grow, together and apart.</h1>
        <p className="text-navy/70 mt-2 max-w-2xl">Gentle, practical guides for real relationships — communication, conflict, trust, mental wellbeing and more.</p>
      </div>

      {!open ? (
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
          {items.map((a) => (
            <button key={a.slug} onClick={() => setOpen(a)} data-testid={`learn-${a.slug}`}
              className="text-left glass rounded-3xl p-7 hover:-translate-y-1 hover:shadow-lg transition-all duration-500">
              <div className="text-[10px] uppercase tracking-widest text-rose">{a.category}</div>
              <div className="font-display text-2xl text-navy mt-2">{a.title}</div>
              <div className="text-sm text-navy/70 mt-2">{a.excerpt}</div>
              <div className="mt-4 text-xs text-navy/60 flex items-center gap-1"><Clock size={12} /> {a.read_min} min read</div>
            </button>
          ))}
        </div>
      ) : (
        <div className="max-w-2xl mx-auto glass rounded-3xl p-10">
          <button data-testid="learn-back" onClick={() => setOpen(null)} className="text-sm text-navy/60 hover:text-navy">← All articles</button>
          <div className="mt-4 text-[10px] uppercase tracking-widest text-rose">{open.category}</div>
          <h2 className="font-display text-4xl text-navy mt-2">{open.title}</h2>
          <div className="text-xs text-navy/60 mt-1 flex items-center gap-1"><Clock size={12} /> {open.read_min} min read</div>
          <div className="mt-6 text-navy/85 leading-relaxed whitespace-pre-line">{open.body}</div>
        </div>
      )}
      {err && <div className="text-sm text-rose-600">{err}</div>}
    </div>
  );
}
